import React, {Component, Fragment} from 'react';
import {Button, Input} from 'reactstrap';
import Dialog from 'apa/containers/Dialog';
import autobind from 'autobind-decorator';
import Loading from 'apa/components/Loading';
import {connect} from 'react-redux';
import * as customers from 'customers/actions/customers';

@connect(
    state => (
        {
            auth: state.apa
        }
    ),
    dispatch => (
        {
            fetchAttachments: customer_id => dispatch(customers.fetchAttachments(customer_id))
        }
    )
)
export default class NewAttachment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isSelected: false,
            isUploading: false,
            data: null
        }
    }

    @autobind
    toggleModal() {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    @autobind
    setFile(event) {
        const target = event.target;
        const file = target.files[0];

        const data = new FormData();
        data.append('file', file);
        this.setState({
            isSelected: true,
            data: data
        })
    }

    @autobind
    confirmUpload() {
        this.setState({isUploading: true});
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`
        };
        const body = this.state.data;
        fetch(
            `/api/customers/${this.props.customer}/attachments/`,
            {headers, method: 'POST', body}
        ).then(
            res => res.json()
        ).then(
            attachment => {
                console.log(attachment);
                this.setState({
                    isUploading: false,
                    isSelected: false,
                    data: null
                });
                this.props.fetchAttachments(this.props.customer);
                this.toggleModal();
            }
        ).catch(
            err => {
                console.log(err)
                this.setState({
                    isUploading: false
                })
            }
        );
    }

    render() {
        return (
            <Fragment>
                <Button color='primary' onClick={this.toggleModal}>
                    Datei hinzufügen
                </Button>
                <Dialog
                    title={'Datei hinzufügen'}
                    toggle={this.toggleModal}
                    isOpen={this.state.isOpen}
                    confirm={this.confirmUpload}
                >
                    {this.state.isUploading &&
                    <Loading/>
                    }
                    {!this.state.isUploading &&
                    <Input type='file' onChange={this.setFile}/>
                    }

                </Dialog>
            </Fragment>
        )
    }
}